import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { History } from 'history';
import { Router } from 'react-router-dom';

const APP_ROUTE_TRIGGER = 'APP_ROUTE_TRIGGER';

interface ICustomRouterProps {
  basename?: string;
  history: History;
}

const CustomRouter: React.FC<ICustomRouterProps> = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  const handleRouteChange = useCallback(
    ((e: CustomEvent<{ path: string }>) => history.push(e.detail.path)) as EventListener,
    [history],
  );

  useEffect(() => {
    document.addEventListener(APP_ROUTE_TRIGGER, handleRouteChange);

    return () => {
      document.removeEventListener(APP_ROUTE_TRIGGER, handleRouteChange);
    };
  }, []);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default CustomRouter;
